<template>
  <div id="app">
      <!--框架lang 切换-->
    <a-config-provider :locale="locale">
        <router-view v-if="isRouterAlive" />
    </a-config-provider>
  </div>
</template>
<script>
import { mapState } from "vuex";
import zhTW from "ant-design-vue/lib/locale-provider/zh_TW";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import enGB from "ant-design-vue/lib/locale-provider/en_US";
import koKR from "ant-design-vue/lib/locale-provider/ko_KR";

import cookie from "./api/cookie";
import ajax from "./api/ajax";
import api from "./api/url";

export default {
  data() {
    return {
      locale: zhTW,
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    ...mapState(["lang"]),
    ...mapState(["pbLoading"])
  },
  watch: {
    lang() {
      this.initLang();
    }
  },
    created(){
    let token = cookie.get('token')
    if(token != undefined){
        let pathError = false;
        try {
            const getActualPath = () => {
                const hash = window.location.hash;
                return hash ? hash.split('?')[0].substring(1) : '/';
            };
            const actualPath = getActualPath();

            if (actualPath == '/dashboard/login') {
              this.$router.push({path: '/dashboard/login'})
            } else if (actualPath == '/dashboard/home') {
              this.$router.push({path: '/dashboard/home'})
            } else if (actualPath == '/dashboard/report') {

            } else if (actualPath != '/previewImgFile') {
              this.$router.push({path: '/page'})
            }
        } catch (e) {
            console.error('路径解析错误:', e);
            pathError = true;
        }
        if(pathError){
            this.$router.push({path:'/page'})
        }
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    initLang() {
      let newCount = this.lang;
      if (newCount == "0") {
        this.locale = zhCN;
      } else if (newCount == "1") {
        this.locale = zhTW;
      } else if (newCount == "2") {
        this.locale = enGB;
      }else if (newCount == "3") {
          this.locale = koKR;
      }
    }
  }
};
</script>
